import React, { useEffect, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';

/** JS **/
import * as Server from 'assets/js/Server';

const brConfig = { fps: 10, qrbox: { width: 300, height: 150 } };

let html5QrCode;

const Scanner = () => {
  //variable
  const navigate = useNavigate();

  const [result, setResult] = useState({
    lat: '',
    lon: '',
    sendType: 'qr',
    qrCode: '',
  });

  //Effect
  useEffect(() => {
    html5QrCode = new Html5Qrcode('reader');

    const oldRegion = document.getElementById('qr-shaded-region');
    oldRegion && oldRegion.remove();

    handleClickAdvanced();
  }, []);

  useEffect(() => {
    const handleBackButton = (event) => {
      //뒤로가기 이벤트
      handleStop();
    };

    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  //Function
  const handleClickAdvanced = () => {
    html5QrCode.start(
      { facingMode: 'environment' },
      brConfig,
      qrCodeSuccessCallback
    ).then(() => {
      // const oldRegion = document.getElementById('qr-shaded-region');
      // if (oldRegion) oldRegion.innerHTML = '';
    });
  };

  const qrCodeSuccessCallback = (decodedText, decodedResult) => {
    handleStop();

    result.qrCode = decodedText;

    postUserData();
  };

  const handleStop = () => {
    try {
      html5QrCode.stop().then(() => {
        html5QrCode.clear();
      }).catch((err) => {
        console.log(err.message);
      });
    } catch (err) {
      console.log(err);
    }
  };

  const moveList = () => {
    handleStop();

    navigate(-1);
  };

  const postUserData = () => {
    Server.sendPost('client/scan', result, postUserDataCallback).then();
  };

  const postUserDataCallback = res => {
    confirmAlert({
      title: 'ok.',
      buttons: [{
        label: 'Yes',
        onClick: () => {
          navigate(-1);
        }
      }]
    });
  };

  return (
    <>
      <TitleDiv></TitleDiv>
      <div style={{ position: 'relative' }}>
        <div id='reader' width='100%'></div>
      </div>
      <BtnWrap className='scan-btn'>
        <button onClick={moveList}>Cancel</button>
      </BtnWrap>
    </>
  );
};

const TitleDiv = styled.div`
  text-align: center;
  margin-top: 30px;
  margin-bottom: 50px;
  font-size: 40px;
`;

const BtnWrap = styled.div`
  margin-top: 45px;

  button {
    width: 100%;
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-weight: 600;
    font-size: 18px;
    color: #ffffff;
    background: #0072B9;
  }

  @media only screen and (max-width: 1024px) {
    padding: 20px;
    height: 100vh;

    .content-inner {
      height: 100%;

      .content {
        max-height: calc(100vh - 270px);
        height: auto !important;
      }
    }

    .scan-btn {
      position: absolute;
      bottom: 0;
      width: 100%;
      margin: 0;

      button {
        width: 100%;
        height: 45px;
        line-height: 45px;
        text-align: center;
        font-weight: 600;
        font-size: 18px;
        color: #ffffff;
        background: #0072B9;
      }
    }
  }
`;

export default Scanner;